import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-navy text-white pt-16 pb-20 md:pt-24 md:pb-32 overflow-hidden relative" data-id="element-97">
      {/* Subtle background pattern/glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl overflow-hidden pointer-events-none" data-id="element-98">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-brand-orange/10 blur-[120px]" data-id="element-99" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-blue-500/10 blur-[120px]" data-id="element-100" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-102">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-103">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-brand-cream" data-id="element-104">
              El Cortafuegos Verbal:{' '}
              <span className="text-brand-orange" data-id="element-105">Cómo Detener los Gritos</span>{' '}
              y Recuperar la Calma con tu Hijo Adolescente en 30 Segundos
            </h1>

            <p className="text-lg sm:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0 font-light" data-id="element-106">
              La guía práctica para padres agotados que quieren recuperar su
              autoridad y dejar de ser bloqueados en WhatsApp, sin recurrir a
              castigos inútiles.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-107">
              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={scrollToPricing} className="w-full sm:w-auto bg-brand-orange hover:bg-orange-600 text-white font-bold text-lg sm:text-xl py-4 px-8 rounded-lg shadow-lg shadow-brand-orange/30 transition-colors" data-id="element-108">
                ¡QUIERO RECUPERAR LA CALMA EN CASA!
              </motion.button>
              <p className="text-sm text-gray-400 italic" data-id="element-109">
                Acceso inmediato tras la compra. Tu relación con tu hijo lo
                vale.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-110">
            <div className="relative aspect-[4/5] sm:aspect-square lg:aspect-[4/5] w-full" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/kodgAcpzoDCnSeNJSzUpAY/20260311_1940_Image_Generation_simple_compose_01kkfgy44kewjs4g0cnv35gyq1.png" alt="Libro El Cortafuegos Verbal" className="object-contain w-full h-full drop-shadow-2xl" data-id="element-112" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}